if (!customElements.get('product-feature')) {
  /**
   * Represents a custom HTML element for a product feature dialog.
   *
   * @class ProductFeature
   * @extends HTMLElement
   *
   * @property {HTMLDialogElement} dialog - The dialog element for the product feature.
   * @property {Object} selectors - An object containing selectors for dialog elements.
   * @property {string} selectors.dialog - Selector for the dialog element.
   * @property {string} selectors.openButton - Selector for the button to open the dialog.
   * @property {string} selectors.closeButton - Selector for the button to close the dialog.
   * @property {string} selectors.content - Selector for the content within the dialog.
   */
  class ProductFeature extends HTMLElement {
    dialog = undefined;
    selectors = {
      dialog: '.js-dialog',
      openButton: '.js-open-dialog',
      closeButton: '.js-close-dialog',
      content: '.js-dialog-content',
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.dialog = this.querySelector(this.selectors.dialog);
      if (this.dialog) {
        this.dialog.addEventListener('click', (e) => {
          if (!e.target.closest(this.selectors.content) || e.target.closest(this.selectors.closeButton)) {
            this.dialog.close();
          }
        });

        const openButton = this.querySelector(this.selectors.openButton);
        if (openButton) {
          openButton.addEventListener('click', (e) => {
            if (e.target.closest('dialog') || window.matchMedia('(min-width: 990px)').matches) {
              return;
            }
            this.dialog.showModal();
          });
        }
      }
    }
  }
  customElements.define('product-feature', ProductFeature);
}
